import {
	Component,
	EventEmitter,
	Input,
	Output,
	ChangeDetectionStrategy,
} from "@angular/core"
import { COMMON_IMPORTS } from "../../common-imports"
import { ApiService } from "@app/services/api.service"
import { LangService } from "@app/services/lang.service"
import { StoreService } from "@app/services/store.service"
import { Check } from "@app/utils/utils.component"
import { DateFormatPipe } from "@app/utils/date-format.pipe"
import { EmailBtn } from "./email-btn"
import { FillBtn } from "./fill-btn"
import { InviteBtn } from "../invite-btn"

@Component({
	selector: "row",
	imports: [
		COMMON_IMPORTS,
		Check,
		DateFormatPipe,
		EmailBtn,
		FillBtn,
		InviteBtn,
	],
	changeDetection: ChangeDetectionStrategy.Eager,
	host: { class: "card-container" },
	template: `
		<div class="card-wrapper">
			<div class="card-details">
				<div class="card-check colstat-extra-small">
					@if (row.hasCheckbox) {
						<app-check
							(onClick)="onCheck.emit(row)"
							[isCheck]="$safeNavigationMigration(row?.checked)"
						/>
					}
				</div>

				<div class="colstat-extra-small">{{ row.id }}</div>
				<div class="colstat-big">{{ row.name }}</div>
				<div class="colstat-small">{{ row.notification_default }}</div>
				<div class="colstat-medium">
					{{ row.latest_invite_date | dateFormat }}
				</div>
				<div class="colstat-medium">
					{{ row.latestInvite?.version?.description }}
				</div>
				<div class="colstat-price">
					{{ row.latest_filled_date | dateFormat }}
				</div>
				<div class="colstat-medium">
					{{ row.latestFill?.version?.description }}
				</div>
				<div class="colstat-extra-small">
					@if (row.latestFill) {
						<button
							class="btn btn-icon"
							titleLang="download"
							icon="download"
							(click)="download(row.latestFill.id)"
						></button>
					}
				</div>
				<div class="colstat-extra-small">
					@if (row.latestFill) {
						<button
							class="btn btn-icon"
							titleLang="pdf-view"
							icon="preview"
							(click)="view(row.latestFill.id)"
						></button>
					}
				</div>
				<div class="colstat-small">
					@if (row.latestFill) {
						<email-btn
							[type]="type"
							[row]="row"
						/>
					}
				</div>

				@if (row.canOpenFillModal) {
					<div class="colstat-extra-small">
						<fill-btn
							[id]="row.id"
							[type]="type"
							[latestVersionId]="latestVersionId"
							(filled)="filled.emit($event)"
						/>
					</div>
					<div class="colstat-extra-small">
						<invite-btn
							[type]="type"
							[id]="row.id"
							[version_id]="latestVersionId"
						/>
					</div>
				}
			</div>
		</div>
	`,
})
export class Row {
	@Input() row: any
	@Input() type: string = ""
	@Input() latestVersionId = null
	@Output() onCheck = new EventEmitter()
	@Output() filled = new EventEmitter()
	constructor(
		public lang: LangService,
		public apiService: ApiService,
		public store: StoreService
	) {}

	download(id: number) {
		this.store.downloadToastFunc(async () => {
			const resPdf: any = await this.apiService.download("download_fill", {
				id,
			})
			if (!resPdf?.size) {
				return this.store.downloadFailedModal()
			}
			this.apiService.downloadFile(
				resPdf,
				this.lang.getVal("policy_form") + ".pdf"
			)
		})
	}
	async view(id: number) {
		const cb = this.apiService.previewDownloadImmediate()
		const resPdf: any = await this.apiService.download("download_fill", {
			id,
		})
		if (!resPdf?.size) {
			return this.store.downloadFailedModal()
		}
		cb(resPdf)
	}
}
